import React from 'react'
import Imgix from 'react-imgix'
import 'lazysizes';

export function setPlaceholderImage(width, height) {
  return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`;
}

const LazyImage = ({ style, src, placeholder, alt = '', width }) => {

  return (
    <Imgix
      className='lazyload'
      style={style}
      src={src}

      width={width}
      disableQualityByDPR
      htmlAttributes={{
        src: `${placeholder}`,
        alt: `${alt}`
      }}

      attributeConfig={{
        src: "data-src",
        srcSet: "data-srcset",
        sizes: "data-sizes",
      }}
    >
    </Imgix>
  )
}


export default LazyImage